import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { checkRedirectUserLogin } from "../../redux/features/authSlice";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import Loader3D from "../../components/Loader/Loader3D";

const PhpRedirectCheck = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [dispatchCompleted, setDispatchCompleted] = useState(false);
  const hash = pathParts[2];
  const os = navigator.userAgent.match(/(?<=\().*?(?=;)/)[0];
  const getBrowserName = () => {
    const userAgent = navigator.userAgent;
  
    if (userAgent.includes("Firefox")) return "Firefox";
    if (userAgent.includes("Edg")) return "Edge";
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) return "Chrome";
    if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) return "Safari";
    if (userAgent.includes("Opera") || userAgent.includes("OPR")) return "Opera";
    return "Unknown";
  };
  useEffect(() => {
    const browser = getBrowserName();
      dispatch(
        checkRedirectUserLogin({
          hashID: hash,
          os: os,
          browser
        })
      ).then((res) => {
        if (res.payload.status === "failed" || res.payload.status === "error") {
          enqueueSnackbar(res.payload.message, { variant: "error" });
          navigate("/auth/login");
        } else if (res.payload.status === "success") {
          // enqueueSnackbar(res.payload.message, {
          //   variant: "success",
          // });
          setIsAuthenticated(true);
          // navigate("/dashboard");
        }
      });
  }, []);

  if (isAuthenticated === null) return (
    <Loader3D/>
  )
  return isAuthenticated ? children : null;
};

export default PhpRedirectCheck;
